<template>
  <div>
    <el-form ref="formRef" :model="topicForm" label-width="88px">
      <el-form-item label="话题名称：">
        <el-input v-model="topicForm.name" placeholder="30字以内" style="width:24em;"/>
      </el-form-item>
      <el-form-item label="排序：">
        <el-input v-model="topicForm.orderNum" placeholder="请输入整数" style="width:24em;"/>
      </el-form-item>
      <el-form-item label="话题标签：">
        <el-input v-model="topicForm.tag" placeholder="选填" style="width:24em;"/>
      </el-form-item>
    </el-form>
    <div class="dialog-footer">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit" v-loading="loading">确定</el-button>
    </div>
  </div>

</template>

<script>
import { postFormData } from "@/api/api"
import { addOrUpdateZoneTopic } from "@/api/url";

export default {
  name: "TagManageDialog",
  props: {
    value: Object
  },
  data() {
    return {
      topicForm: this.value.topicForm,
      idx: this.value.ids,
      loading: false,
    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },

    //更改或添加
    headImgUpdate() {
      this.$refs.headImg.click();
    },

    //选取图片
    headImgChanged(e) {
      if(e.target.files[0]) {
        this.files = e.target.files[0];
        var windowURL = window.URL || window.webkitURL;
        this.src = windowURL.createObjectURL(this.files);
      }
    },

    summit() {
      if(!this.topicForm.name) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '话题名称不能为空',
          type: 'warning'
        });
        return false
      }
      if(!this.topicForm.orderNum) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '排序不能为空',
          type: 'warning'
        });
        return false
      }
      this.loading = true
      let param = {};
      param['id'] = this.topicForm.id?this.topicForm.id:0;
      param['name'] = this.topicForm.name;
      param['orderNum'] = this.topicForm.orderNum;
      param['tag'] = this.topicForm.tag;
      postFormData(addOrUpdateZoneTopic, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm', param)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
        this.loading = false
      }).catch(()=>{
        this.loading = false
      })
    }
  },
  mounted() {
  }
}
</script>

<style scoped>
.add {
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  border: 1px dashed #ececec;
  font-size: 30px;
  cursor: pointer;
  float: left;
}
</style>
